const getLocale = state => state.preferences.locale;

export { getLocale };
